import React from 'react'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers'
import { DigitalClock } from '@mui/x-date-pickers/DigitalClock'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { IGeneralInfo } from '../../../types/app'

interface DeliverySchedulerProps {
  date: Date | null
  setDate: (value: Date | null) => void
  time: Date | null
  setTime: (value: Date | null) => void
  allHours: boolean
  nearestValidTime: Date
  generalInfo: IGeneralInfo
  isMobile: boolean
  t: (key: string) => string
}

const DeliveryScheduler: React.FC<DeliverySchedulerProps> = ({
  date,
  setDate,
  time,
  setTime,
  allHours,
  nearestValidTime,
  generalInfo,
  isMobile,
  t,
}) => (
  <div className='checkout-page__container-delivery_method'>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className='checkout-page__container-delivery_method-order-tab'>
        <MobileDatePicker
          views={['month', 'day']}
          minDate={new Date()}
          defaultValue={new Date()}
          value={date}
          timezone='Europe/Chisinau'
          onChange={setDate}
          slotProps={{
            textField: {
              variant: 'outlined',
              sx: {
                outline: 'none',
                '.Mui-focused': {
                  boxShadow: 'var(--color-primary) 0 0 0 2px',
                  background: '#fff',
                  outline: 'var(--color-primary)',
                  borderColor: 'none',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none !important',
                  },
                },
              },
            },
            day: {
              sx: {
                '&.MuiPickersDay-root.Mui-selected': {
                  backgroundColor: 'var(--color-primary)',
                },
              },
            },
            actionBar: { sx: { '.MuiButton-root': { color: 'var(--color-primary)' } } },
          }}
        />
        <div className='checkout-page__digital-clock'>
          {allHours ? (
            <DigitalClock
              timeStep={15}
              skipDisabled
              shouldDisableTime={() => false}
              timezone='Europe/Chisinau'
              sx={{
                '.MuiDigitalClock-item': {
                  transition: 'all 0.2s ease-in-out',
                  '&.Mui-selected': { backgroundColor: 'var(--color-primary)' },
                },
              }}
              minTime={
                new Date(0, 0, 0, Number(generalInfo?.minTime.split(':')[0]))
              }
              maxTime={
                new Date(0, 0, 0, Number(generalInfo?.maxTime.split(':')[0]))
              }
              ampm={false}
              value={time}
              onChange={setTime}
            />
          ) : (
            <DigitalClock
              timeStep={15}
              skipDisabled
              timezone='Europe/Chisinau'
              shouldDisableTime={() => false}
              sx={{
                '.MuiDigitalClock-item': {
                  transition: 'all 0.2s ease-in-out',
                  '&.Mui-selected': { backgroundColor: 'var(--color-primary)' },
                },
              }}
              minTime={nearestValidTime}
              maxTime={
                new Date(0, 0, 0, Number(generalInfo?.maxTime.split(':')[0]))
              }
              ampm={false}
              value={time}
              onChange={setTime}
            />
          )}
        </div>
      </div>
    </LocalizationProvider>
  </div>
)

export default DeliveryScheduler
